/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

export class InvoiceExchangeRateDTO {
  uuid: string | null = null;
  fromCurrencyCode: string | null = null;
  toCurrencyCode: string | null = null;
  value: number | null = null;
  date: string | null = null;
}
